import { TableBody, TableCell, TableRow, Tooltip } from "@mui/material";
import React from "react";
import { Circle, RotatingOffRadar } from "../svgs/SVGs";

const StagePoisComponent = ({ journeyData, setStageTotalPOIsPoints }) => {
  const stagePois = journeyData?.ResultData?.StagePois || [];

  //console.log("journeyData", journeyData);
  const stageTypeId = journeyData?.ResultData?.StageTypeId;

  const StageTypeEnum = {
    Normal: 1,
    MultipleBonus: 2,
    Neutral: 3,
    BonusGroup: 4,
    BonusGroupMultiple: 5,
  };

  const BonusGroupStatus = {
    NotStarted: 0,
    InProgress: 1,
    Finished: 2,
  };

  let poisTotals = 0;
  let previousBonusGroupId = 0;

  return (
    <TableBody>
      {stagePois.length > 0 ? (
        stagePois
          .sort((a, b) => {
            if (
              stageTypeId === StageTypeEnum.BonusGroup ||
              stageTypeId === StageTypeEnum.BonusGroupMultiple
            ) {
              return (
                a.PointTypeId - b.PointTypeId ||
                a.BonusGroupName.localeCompare(b.BonusGroupName)
              );
            }
            return a.PointTypeId - b.PointTypeId;
          })
          .map((pois, index) => {
            console.log("pois.IsJokerOffRadar", pois.IsJokerOffRadar);
            const offRadarIcon = pois.IsJokerOffRadar ? (
              <Tooltip title="POIs Occured during Joker Off Radar">
                {RotatingOffRadar()}
              </Tooltip>
            ) : null;

            const ignorepoisColor =
              (pois.BonusDiscarded || pois.IsJokerOffRadar) &&
              (stageTypeId === StageTypeEnum.BonusGroup ||
                stageTypeId === StageTypeEnum.BonusGroupMultiple)
                ? { color: "#bfbfbf", marginLeft: "20px" }
                : (pois.BonusDiscarded || pois.IsJokerOffRadar) &&
                  !(
                    stageTypeId === StageTypeEnum.BonusGroup ||
                    stageTypeId === StageTypeEnum.BonusGroupMultiple
                  )
                ? { color: "#bfbfbf" }
                : !(pois.BonusDiscarded || pois.IsJokerOffRadar) &&
                  (stageTypeId === StageTypeEnum.BonusGroup ||
                    stageTypeId === StageTypeEnum.BonusGroupMultiple)
                ? { marginLeft: "20px" }
                : {};

            const strikethroughClass =
              pois.BonusDiscarded || pois.IsJokerOffRadar
                ? "red-line-through"
                : "";
            const cancelMarksHtml =
              pois.BonusDiscarded || pois.IsJokerOffRadar ? " (0)" : "";

            if (!pois.BonusDiscarded && !pois.IsJokerOffRadar) {
              if (
                stageTypeId === StageTypeEnum.BonusGroup ||
                stageTypeId === StageTypeEnum.BonusGroupMultiple
              ) {
                if (previousBonusGroupId !== pois.BonusGroupId) {
                  poisTotals += pois.TotalPoints;
                  setStageTotalPOIsPoints(poisTotals);
                }
              } else {
                poisTotals += parseFloat(pois.Points);
                setStageTotalPOIsPoints(poisTotals);
              }
            }

            let statusText = "";
            if (
              (stageTypeId === StageTypeEnum.BonusGroup ||
                stageTypeId === StageTypeEnum.BonusGroupMultiple) &&
              previousBonusGroupId !== pois.BonusGroupId
            ) {
              previousBonusGroupId = pois.BonusGroupId;
              statusText = (() => {
                if (pois.BonusGroupStatus === BonusGroupStatus.NotStarted)
                  return "Not Started";
                if (pois.BonusGroupStatus === BonusGroupStatus.InProgress)
                  return "InComplete";
                if (
                  pois.BonusGroupStatus === BonusGroupStatus.Finished &&
                  pois.BonusDiscarded
                )
                  return "Finished But Late";
                if (pois.BonusGroupStatus === BonusGroupStatus.Finished)
                  return "Finished";
                return "";
              })();

              return (
                <>
                  {pois.BonusGroupId > 0 ? (
                    <React.Fragment key={`${pois.BonusGroupId}-${index}`}>
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          style={{ fontSize: "15px", whiteSpace: "nowrap" }}
                        >
                          <b>{pois.BonusGroupName}</b>{" "}
                          {Circle(pois.BonusGroupColor)} {statusText}
                        </TableCell>
                        <TableCell
                          style={{ whiteSpace: "nowrap" }}
                          colSpan="1"
                          className="tbody-custscroll-price"
                          align="right"
                        >
                          <span className={strikethroughClass}>
                            {pois.TotalPoints.toFixed(2)}
                          </span>
                          <span>{cancelMarksHtml}</span>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </React.Fragment>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} style={{ fontSize: "15px" }}>
                        <b>Other than Bonus Group</b>
                      </TableCell>
                      <TableCell colSpan="3"></TableCell>
                    </TableRow>
                  )}
                  <TableRow key={`${pois.BonusGroupId}-${index}POIs`}>
                    <TableCell colSpan="4">
                      <span style={ignorepoisColor}>{pois.Pois}</span>{" "}
                      {offRadarIcon}
                    </TableCell>
                    <TableCell>
                      {pois.PointTypeId === 4 && pois.MaxSpeedInPois > 0 ? (
                        <span>{Math.round(pois.MaxSpeedInPois, 2)} km/u</span>
                      ) : null}
                    </TableCell>
                    <TableCell
                      colSpan="2"
                      className="tbody-custscroll-price"
                      style={{ paddingRight: ".75rem" }}
                      align="right"
                    >
                      <span className={strikethroughClass}>
                        {stageTypeId === StageTypeEnum.BonusGroup ||
                        stageTypeId === StageTypeEnum.BonusGroupMultiple
                          ? ""
                          : parseFloat(pois.Points).toFixed(2)}
                      </span>
                    </TableCell>
                  </TableRow>
                </>
              );
            }

            return (
              <TableRow key={index}>
                <TableCell
                  colSpan={
                    stageTypeId === StageTypeEnum.BonusGroup ||
                    stageTypeId === StageTypeEnum.BonusGroupMultiple
                      ? 4
                      : 3
                  }
                >
                  <span style={ignorepoisColor}>{pois.Pois}</span>{" "}
                </TableCell>
                <TableCell align="right">
                  {offRadarIcon}
                  {pois.PointTypeId === 4 && pois.MaxSpeedInPois > 0 ? (
                    <span>{Math.round(pois.MaxSpeedInPois, 2)} km/u</span>
                  ) : null}
                </TableCell>
                <TableCell
                  colSpan="1"
                  className="tbody-custscroll-price"
                  style={{ paddingRight: ".75rem" }}
                  align="right"
                >
                  <span className={strikethroughClass}>
                    {stageTypeId === StageTypeEnum.BonusGroup ||
                    stageTypeId === StageTypeEnum.BonusGroupMultiple
                      ? ""
                      : parseFloat(pois.Points).toFixed(2)}
                  </span>
                </TableCell>
                {!(
                  stageTypeId === StageTypeEnum.BonusGroup ||
                  stageTypeId === StageTypeEnum.BonusGroupMultiple
                ) && <TableCell></TableCell>}
              </TableRow>
            );
          })
      ) : (
        <TableRow key={"customerRow"}>
          <TableCell style={{ textAlign: "center" }}>
            {"Admin Result Pois Points None"}
          </TableCell>
        </TableRow>
      )}
      <TableRow
        key={"customRow2"}
        className="total-line"
        style={{ backgroundColor: "#f2f2f2" }}
      >
        <TableCell colSpan={3}>{"Pois Total"}</TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell align="right" className="tbody-custscroll-price">
          {poisTotals.toFixed(2)}
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default StagePoisComponent;
